import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../index.css";
import Commonheader from "../CommonUtils/Commonheader";
import ServiceCards from "../NocComponents/ServiceCards";

function Footer() {
    return (
        <div className="footer-brand-logo">
            <p>Designed and Developed by</p>
            <img
                src="../images/apcfss-logo-white.svg"
                className="img-fluid"
                alt="apcfss-logo-white"
            />
        </div>
    );
}

export default function RusaDashboard() {
    return (
        <>
            <Commonheader />

            <div className="dashboard-service-wrapper" >
                <ServiceCards />
            </div>

            <Footer />
        </>
    );
}